import previewView from "./previewView";
import View from "./view";
class BookmarksView extends View
{
  constructor()
  {
    super(
      document.querySelector(".bookmarks__list"),
      "No bookmarks yet. Find a nice recipe and bookmark it 🙂"
    )
  }
  addHandlerLoadBookmarks(handler)
  {
    window.addEventListener("load",handler);
  }
  _generateMarkup()
  {
    return this._data.map(bookmark=>previewView.render(bookmark,false)).join(" ");
    
  }
}

export default new BookmarksView();